export default "__VITE_ASSET__DlBzEVwg__"